const OCR_LANGUAGES = [
  { code: 'fr', label: 'Francais' },
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Espanol' },
  { code: 'de', label: 'Deutsch' },
  { code: 'it', label: 'Italiano' },
  { code: 'pt', label: 'Portugues' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'ru', label: 'Russkiy' },
  { code: 'ar', label: 'Arabi' },
  { code: 'zh', label: 'Zhongwen' },
  { code: 'ja', label: 'Nihongo' },
  { code: 'ko', label: 'Hangugeo' },
];

export default function UploadOptions({ options, onChange }) {
  return (
    <div className="upload-options">
      <div className="option-group">
        <label>Format :</label>
        <select
          value={options.format}
          onChange={(e) => onChange({ ...options, format: e.target.value })}
        >
          <option value="markdown">Markdown</option>
          <option value="html">HTML</option>
          <option value="json">JSON</option>
        </select>
      </div>
      <div className="option-group">
        <label>Langue OCR :</label>
        <select
          value={options.lang}
          onChange={(e) => onChange({ ...options, lang: e.target.value })}
        >
          {OCR_LANGUAGES.map(({ code, label }) => (
            <option key={code} value={code}>
              {label}
            </option>
          ))}
        </select>
      </div>
      <div
        style={{ display: 'none' }}
        className="toggle-wrapper"
        onClick={() => onChange({ ...options, legal: !options.legal })}
      >
        <div className={`toggle ${options.legal ? 'on' : ''}`} />
        <span>Format juridique</span>
      </div>
    </div>
  );
}
